document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".db-my-trip .link-to-hotel").forEach(link => {
        link.addEventListener("click", (e) => {
            e.stopPropagation();

            const parent = (e.currentTarget as HTMLElement).closest(".db-my-trip");
            const hotelUrl = parent?.getAttribute("data-hotel-url");

            if (!hotelUrl) return;

            if (window.innerWidth > 992) {
                // desktop → new tab
                e.preventDefault();
                window.open(hotelUrl, "_blank");
            } else {
                // mobile / tablet → same tab
                window.location.href = hotelUrl;
            }
        });
    });
});
